import { ExperimentalPanel as Panel, ScrollArea, StackedGrow } from '@statsbomb/kitbag-components';
import { PositionGroupSelector } from '@statsbomb/kitbag-global-football';
import { useAtom, useSetAtom } from 'jotai';
import { useMatch } from 'react-router-dom';
import {
  radarTemplatePositionGroupAtom,
  radarTemplateLimitModesAtom,
  radarTemplateCustomLimitsAtom,
} from '@/atoms/radar';
import { MainContent } from './MainContent';
import { RadarTemplateNameInput } from './RadarTemplateNameInput';

const PositionGroupSelect = () => {
  const isPlayerSection = !!useMatch('/:locale/player/*');
  const [selectedPositionGroup, setSelectedPositionGroup] = useAtom(radarTemplatePositionGroupAtom);
  const setLimitModes = useSetAtom(radarTemplateLimitModesAtom);
  const setCustomLimits = useSetAtom(radarTemplateCustomLimitsAtom);

  return (
    <ScrollArea as={StackedGrow}>
      <RadarTemplateNameInput />
      {isPlayerSection && (
        <MainContent>
          <Panel background="tertiary" padding="regular">
            <PositionGroupSelector
              value={selectedPositionGroup}
              onChange={(_event, positionGroup) => {
                setSelectedPositionGroup(positionGroup);
                setLimitModes({});
                setCustomLimits({});
              }}
            />
          </Panel>
        </MainContent>
      )}
    </ScrollArea>
  );
};

export default PositionGroupSelect;
